export default __webpack_public_path__ + "static/roadmap-2-3895ce5e39c5d9e391a22916c10a7409.mp4";